<template>
  <parent>
    <loading-page v-if="loading" />
    <form-wrapper
      v-else
      full-width
    >
      <template v-slot:body>
        <paper>
          <template v-slot:title>
            <p class="mb-0">
              Info
            </p>
          </template>
          <div class="px-2 col-12 col-lg-6 m-auto">
            <div class="information">
              <label>Name</label>
              <p class="info">
                {{ requestPolicy.name || '-' }}
              </p>
            </div>
            <div class="information">
              <label>Comment</label>
              <p class="info">
                {{ requestPolicy.comment || '-' }}
              </p>
            </div>
          </div>
        </paper>

        <paper>
          <template v-slot:title>
            <div>
              <p>Request key contents</p>
              <span
                class="text-regular"
              >The request key includes the headers, cookies, and query
                strings in the cache policy, as follows:</span>
            </div>
          </template>
          <div class="px-2 col-12 col-lg-6 m-auto">
            <div class="d-flex">
              <div class="information w-50">
                <label>Headers</label>
                <p class="info">
                  {{ header }}
                </p>
                <div
                  v-if="headers.length > 0"
                  class="mb-1"
                >
                  <template v-for="head in headers">
                    <span
                      :key="head"
                      class="custom-tags"
                    > {{ head }} </span>
                  </template>
                </div>
              </div>

              <div class="information w-50">
                <label>Cookies</label>
                <p class="info">
                  {{ cookie }}
                </p>
                <div
                  v-if="cookies.length > 0"
                  class="mb-1"
                >
                  <template v-for="cook in cookies">
                    <span
                      :key="cook"
                      class="custom-tags"
                    > {{ cook }} </span>
                  </template>
                </div>
              </div>
            </div>

            <div class="d-flex">
              <div class="information w-50">
                <label>Query strings</label>
                <p class="info">
                  {{ queryString }}
                </p>
                <div
                  v-if="queryStrings.length > 0"
                  class="mb-1"
                >
                  <template v-for="query in queryStrings">
                    <span
                      :key="query"
                      class="custom-tags"
                    > {{ query }} </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </paper>
      </template>

      <template v-slot:footer>
        <b-button
          v-if="goBack"
          variant="bg-white"
          @click="onGoBack()"
        >
          Go Back
        </b-button>
      </template>
    </form-wrapper>
  </parent>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'RequestPoliciesInfo',
  components: {
    Paper,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      policyId: null,
      goBack: false,
    }
  },
  computed: {
    header() {
      const header = this.requestPolicy.headerOptions.findIndex(
        x => x.id === this.requestPolicy.headerPolicyId,
      )
      return this.requestPolicy.headerOptions[header].value
    },
    cookie() {
      const cookie = this.requestPolicy.cookieOptions.findIndex(
        x => x.id === this.requestPolicy.cookiePolicyId,
      )
      return this.requestPolicy.cookieOptions[cookie].value
    },
    queryString() {
      const queryString = this.requestPolicy.queryStringOptions.findIndex(
        x => x.id === this.requestPolicy.queryStringPolicyId,
      )
      return this.requestPolicy.queryStringOptions[queryString].value
    },
    loading() {
      return this.$store.state.requestPolicies.gettingRequestPolicy
    },
    requestPolicy() {
      return this.$store.state.requestPolicies.requestPolicy
    },
    cookies() {
      return this.requestPolicy.cookies
    },
    headers() {
      return this.requestPolicy.headers
    },
    queryStrings() {
      return this.requestPolicy.queryStrings
    },
  },
  created() {
    this.policyId = this.id === null ? this.$route.params.requestId : this.id
    this.$store
      .dispatch('requestPolicies/getRequestPolicy', this.policyId)
      .catch(err => redirectError(err, this.$router, this.$route.path))

    this.goBack = this.$route.query.v !== undefined
  },
  methods: {
    onGoBack() {
      this.$router.push({ name: 'request-policies' })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-tags {
  border: 1px solid #e0e5eb;
  padding: 12px;
  margin: 0 5px 5px 0;
  display: inline-flex;
  word-break: break-all;
}
</style>
